/**
 * Ticket KN6: EIN Ort für die Schlüssel des Cockpit-Zwischenspeichers.
 *
 * Warum hier und nicht in den Hooks: Die Sitzungsabfrage wird von vielen
 * Stellen erneuert (Fragebogen abgeschickt, Zugangsdaten übergeben, Aufgabe
 * abgehakt). Läge der Schlüssel an jeder dieser Stellen als Zeichenkette,
 * würde eine Umbenennung stillschweigend ins Leere greifen.
 */

import type { QueryClient } from "@tanstack/react-query";

/** Sitzungsstatus des Kundencockpits (`getMyCockpitStatus`). */
export const COCKPIT_SESSION_KEY = ["cockpit", "status"] as const;

/** Zusatzangaben der Cockpit-Startseite (`getMyCockpitHome`). */
export const COCKPIT_HOME_KEY = ["cockpit", "home"] as const;

/** Sitzungsstatus des internen Bereichs (`getMyAdminStatus`). */
export const ADMIN_SESSION_KEY = ["admin-session"] as const;

/**
 * Nach einer Handlung, die Bereiche, Module, Phase, Inhaltskennzeichen oder
 * die Checkliste verändert: Sitzung und Startseite neu holen.
 *
 * Bewusst `invalidateQueries` (nicht `removeQueries`): Es handelt sich um
 * dasselbe Konto, der bisherige Stand darf also bis zur Antwort weiter
 * angezeigt werden – so flackert die Seitenleiste nicht.
 */
export function refreshCockpitSession(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: COCKPIT_SESSION_KEY });
  void queryClient.invalidateQueries({ queryKey: COCKPIT_HOME_KEY });
}

/**
 * Bei Anmeldung, Abmeldung und Kontowechsel: Speicher LEEREN, nicht nur für
 * ungültig erklären. `invalidateQueries` würde die Angaben des vorherigen
 * Kontos bis zur neuen Antwort weiter ausliefern.
 */
export function clearCockpitCache(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: ["cockpit"] });
}

/** Gegenstück für den internen Bereich. */
export function clearAdminCache(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: ADMIN_SESSION_KEY });
  queryClient.removeQueries({ queryKey: ["staff-profile"] });
  queryClient.removeQueries({ queryKey: ["my-staff-profile"] });
  queryClient.removeQueries({ queryKey: ["admin"] });
}
